export default function Footer() {
  return (
    <footer style={{
      background: 'var(--bg-secondary)',
      borderTop: '1px solid var(--border)',
      padding: 'var(--spacing-2xl) 0',
      marginTop: 'var(--spacing-3xl)'
    }}>
      <div className="container">
        <div className="grid grid-3">
          {/* Company Info */}
          <div>
            <div className="flex flex-center mb-md">
              <img
                src="/icons/logo.png"
                alt="Ascensos App Vortex"
                style={{
                  height: '32px',
                  filter: 'brightness(1) invert(0)'
                }}
              />
              <span style={{
                marginLeft: 'var(--spacing-sm)',
                fontSize: '1.125rem',
                fontWeight: '700',
                color: 'var(--text-primary)'
              }}>
                Vortex Software
              </span>
            </div>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
              Especialistas en aplicaciones móviles innovadoras para educación y gestión.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ marginBottom: 'var(--spacing-lg)' }}>Enlaces rápidos</h4>
            <div className="flex flex-wrap" style={{ flexDirection: 'column', gap: 'var(--spacing-sm)' }}>
              <a href="#about" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Sobre nosotros</a>
              <a href="#features" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Características</a>
              <a href="#howitworks" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Cómo funciona</a>
              <a href="#availability" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Descargar</a>
              <a href="/privacy-policy.html" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Política de Privacidad</a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ marginBottom: 'var(--spacing-lg)' }}>Contacto</h4>
            <div className="flex flex-wrap" style={{ flexDirection: 'column', gap: 'var(--spacing-sm)' }}>
              <a href="mailto:centralvortexapk@gmail.com" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
                centralvortexapk@gmail.com
              </a>
              <a href="#contact" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
                Formulario de contacto
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid var(--border)',
          marginTop: 'var(--spacing-2xl)',
          paddingTop: 'var(--spacing-lg)',
          textAlign: 'center',
          color: 'var(--text-muted)',
          fontSize: '0.875rem'
        }}>
          © {new Date().getFullYear()} Vortex Software. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  )
} 